import { getDatabase, ref, set, get, update } from "firebase/database";

// Create or update user profile
export const createUserProfile = async (user) => {
  if (!user) return null;
  
  const db = getDatabase();
  const userRef = ref(db, `users/${user.uid}`);
  const userSnapshot = await get(userRef);
  
  if (!userSnapshot.exists()) {
    const userData = {
      displayName: user.displayName || user.email?.split('@')[0] || 'Bean Lover',
      email: user.email,
      createdAt: new Date().toISOString(),
      beansUploaded: 0,
      totalLikesReceived: 0
    };
    
    await set(userRef, userData);
    return userData;
  }
  
  return userSnapshot.val();
};

// Get user profile
export const getUserProfile = async (userId) => {
  const db = getDatabase();
  const userRef = ref(db, `users/${userId}`);
  const snapshot = await get(userRef);
  return snapshot.exists() ? snapshot.val() : null;
};

// Update user stats
export const updateUserStats = async (userId, updates) => {
  const db = getDatabase();
  const userRef = ref(db, `users/${userId}`);
  await update(userRef, updates);
};

// Check if user has liked a bean
export const hasUserLikedBean = async (userId, beanId) => {
  const db = getDatabase();
  const likeRef = ref(db, `userLikes/${userId}/${beanId}`);
  const snapshot = await get(likeRef);
  return snapshot.exists();
};

// Get user's liked beans
export const getUserLikedBeans = async (userId) => {
  const db = getDatabase();
  const likesRef = ref(db, `userLikes/${userId}`);
  const snapshot = await get(likesRef);
  return snapshot.exists() ? Object.keys(snapshot.val()) : [];
};